export default function LongText({response, setResponse, disabled = false, className = '', placeholder = 'Type an answer...', question}) {
  const handleChange = (event) => {
    setResponse(event.target.value);
  }

  const rows = question.settings.numberOfRows

  return (
    <div className={`answers grow ${className}`}>
      <textarea
        rows={rows}
        style={{resize: 'vertical'}}
        placeholder={placeholder}
        onChange={handleChange}
        disabled={disabled}
        value={response || ''}>
      </textarea>
    </div>
  )
}
